import { CustomI18n as I18n } from '/src/utils/custom_i18n'

export default class CreationInspectionModel {
  name = I18n.t('inspections.title')

  singularName = I18n.t('inspections.description')

  paramName = 'inspection'

  templateType = 'inspection'

  route = 'inspections'

  flexible = true

  columns = [
    {
      id: 1,
      description: 'inspected_type',
      title: I18n.t('inspections.module'),
      orderOnForm: 1,
      type: 'module_filter'
    },
    {
      id: 2,
      description: 'inspect_date',
      orderOnForm: 4,
      title: I18n.t('inspections.inspect_date'),
      type: 'date'
    },
    {
      id: 3,
      description: 'responsible',
      field: 'responsible.full_name',
      title: I18n.t('inspections.responsible_id'),
      foreignKey: 'employees',
      foreignAttribute: 'responsible_id',
      required: true,
      orderOnForm: 5,
      searchFields: ['name', 'last_name'],
      searchExtraQuery: {
        where: { '[work_positions][operational]': 1, is_inspection_responsible: 1 }
      },
      searchRoute: 'employees',
      textDisplayFields: ['full_name'],
      type: 'search'
    },
    {
      id: 4,
      description: 'eav_template_id',
      hideOnForm: true,
      type: 'integer'
    },
    {
      id: 5,
      description: 'request_id',
      virtualField: true,
      hideOnForm: true,
      type: 'integer'
    },
    {
      id: 6,
      description: 'inspected_id',
      virtualField: true,
      hideOnForm: true,
      type: 'integer'
    },
    {
      id: 7,
      description: 'frequency_interval',
      title: I18n.t('inspections.frequency'),
      min: 1,
      hideOnForm: true,
      required: false, 
      orderOnForm: 3,
      type: 'integer',
    },
    {
      id: 8,
      description: 'recurrence_type',
      title: I18n.t('inspections.period'),
      metadata: JSON.stringify([
        { id: 'day', description: I18n.t('inspections.repeat_every_value.day') },
        { id: 'month', description: I18n.t('inspections.repeat_every_value.month') },
        { id: 'year', description: I18n.t('inspections.repeat_every_value.year') }
      ]),
      hideOnForm: true,
      required: false, 
      orderOnForm: 2,
      type: 'drop',
    }
  ]
}
